import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleProp, StyleSheet, TextStyle, View, ViewStyle } from 'react-native'

const maxCount = 99

export interface BadgeProps {
    count: number
    color?: ColorEnum
    inverted?: boolean
    style?: StyleProp<ViewStyle>
    textStyle?: StyleProp<TextStyle>
}

const Badge: FC<BadgeProps> = ({
    count,
    inverted = false,
    style,
    textStyle,
    color = ColorEnum.BRICK_600,
}) => {
    return (
        <View
            style={[
                styles.container,
                { backgroundColor: !inverted ? ColorEnum.WHITE : color },
                style,
            ]}
        >
            <Typography.Description
                style={[styles.text, { color: !inverted ? color : ColorEnum.WHITE }, textStyle]}
            >
                {count > maxCount ? `${maxCount}+` : count}
            </Typography.Description>
        </View>
    )
}

export default Badge

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 16,
        height: 16,
        paddingVertical: 2,
        paddingHorizontal: 5,
        borderRadius: 300,
    },
    text: {
        fontSize: 10,
        fontFamily: FontEnum.SatoshiBold,
        // Android-specific centering
        textAlignVertical: 'center',
        includeFontPadding: false,
    },
})
